import { defineComponent as _defineComponent } from 'vue'
import { ref, onBeforeUnmount } from 'vue';
import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons';


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchbarInput',
  props: {
    modelValue: null,
    placeholder: { default: 'Search' },
    debounce: { default: 0 },
    autocorrect: { default: 'off' },
    autocomplete: { default: 'off' }
  },
  emits: ["update:modelValue", "onChange", "onClear", "onBlur"],
  setup(__props: any, { expose, emit }: { emit: ({
	(e: 'update:modelValue', value: string): void;
	(e: 'onChange', event: { target: { value: string } }): void;
	(e: 'onClear'): void;
	(e: 'onBlur'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { modelValue: string, placeholder: string, debounce: number, autocorrect: string, autocomplete: string };





const inputRef = ref<HTMLInputElement | null>(null);
let debounceTimer: NodeJS.Timeout | null = null;

function handleInput(event: Event) {
	const target = event.target as HTMLInputElement;
	const value = target.value;

	emit('update:modelValue', value);

	// Clear existing timer
	if (debounceTimer) {
		clearTimeout(debounceTimer);
	}

	// Set new timer if debounce is specified
	if (props.debounce > 0) {
		debounceTimer = setTimeout(() => {
			emit('onChange', { target: { value } });
		}, props.debounce);
	} else {
		emit('onChange', { target: { value } });
	}
}

function handleClear() {
	if (debounceTimer) {
		clearTimeout(debounceTimer);
		debounceTimer = null;
	}

	emit('update:modelValue', '');
	emit('onClear');
	emit('onChange', { target: { value: '' } });
	inputRef.value?.focus();
}

function handleBlur() {
	emit('onBlur');
}

function setFocus() {
	inputRef.value?.focus();
}

onBeforeUnmount(() => {
	if (debounceTimer) {
		clearTimeout(debounceTimer);
		debounceTimer = null;
	}
});

expose({
	setFocus,
});

return { __sfc: true,props, emit, inputRef, debounceTimer, handleInput, handleClear, handleBlur, setFocus, faSearch, faTimes }
}

})